export default __webpack_public_path__ + "static/media/add-circle.b345311a.svg";